import { render, staticRenderFns } from "./DeclareAndProtocol.vue?vue&type=template&id=adb72a12&scoped=true"
import script from "./DeclareAndProtocol.vue?vue&type=script&lang=js"
export * from "./DeclareAndProtocol.vue?vue&type=script&lang=js"
import style0 from "./DeclareAndProtocol.vue?vue&type=style&index=0&id=adb72a12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adb72a12",
  null
  
)

export default component.exports